import axios from "../../../utils/authAxios";
const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/SecurityConfiguration";

export const getCameraSystemList = async () => {
  return axios.get(`${api_base_url}/GetCameraSystem`).then((res) => {
    return res;
  });
};

export const addCameraSystem = async (newCameraSystem) => {
  const { data } = await axios.post(`${api_base_url}/AddCameraSystem`, {
    ...newCameraSystem,
  });
  return data;
};

export const deleteCameraSystem = async (ids) => {
  const { data } = await axios.delete(
    `${api_base_url}/DeactivateCameraSystem`,
    {
      data: ids,
    }
  );
  return data;
};

export const updateCameraSystem = async (editCameraSystem) => {
  const { data } = await axios.put(
    `${api_base_url}/EditCameraSystem`,
    editCameraSystem
  );
  return data;
};
